/* eslint-disable max-lines-per-function */
import { ReactNode, useCallback } from 'react';

import { PhoneNumber } from '@dreryk/phone-number-common-api';
import { CurrentHealthcareProviderPaymentsConfigurationEnabledQuery } from '@dreryk/egabinet-online-payments-integration-frontend-api';

import { isDemo } from '@dreryk/demo-variant-frontend';
import { ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';
import { performCqrsQueryFind } from '@dreryk/command-query-react-common';

import { protectFeature } from '~libs.shared.system';

import { translationKeys } from '../../../translations';

import { AppointmentAdvancePaymentLinkModal } from './AppointmentAdvancePaymentLinkModal';

type AppointmentAdvancePaymentLinkShowModalEventInterceptorProps = Readonly<{
   onlinePaymentId: string | undefined;
   phoneNumber: PhoneNumber | null;
   children: ReactNode;
}>;

export const AppointmentAdvancePaymentLinkShowModalEventInterceptor = (
   props: AppointmentAdvancePaymentLinkShowModalEventInterceptorProps
): JSX.Element => {
   const shouldShowModal = useCallback(async () => {
      if (isDemo()) {
         return false;
      }
      const advancePaymentEnabled = protectFeature('searchingPrivateMedicalServices', true, false);
      const onlinePaymentsIntegrationExists = await performCqrsQueryFind(
         () => new CurrentHealthcareProviderPaymentsConfigurationEnabledQuery()
      );

      if (!advancePaymentEnabled || !onlinePaymentsIntegrationExists || !props.onlinePaymentId) {
         return false;
      }

      return {
         onlinePaymentId: props.onlinePaymentId,
      };
   }, [props.onlinePaymentId]);

   return (
      <ShowModalEventInterceptor
         shouldShowModal={shouldShowModal}
         testId={'appointmentAdvancePaymentLink'}
         title={translationKeys.linkToPayment}
         footerItemsHidden
         modalWidth={ModalWidth.NORMAL}
         content={({ resolve, result: { onlinePaymentId } }) => (
            <AppointmentAdvancePaymentLinkModal
               onClose={resolve}
               onlinePaymentId={onlinePaymentId}
               phoneNumber={props.phoneNumber}
            />
         )}
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
